import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-top: var(--gap);
`;

export const Heading = styled.h3``;

export const Items = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
`;
